module.exports = __webpack_public_path__ + "static/media/Other1.65775f7a.svg";